import { ANNULUS_CONDITION } from '../annulus-condition';
import { DETAILED_RESULTS_FAD_FLEX } from '../detailed-results-fad-flex';
import { FadFlexStructure } from './fad-flex-structure.model';

export class FadFlexInstructions {
  id?: number;
  histogram: boolean;
  frictionCoefficient: number;
  detailedResults: DETAILED_RESULTS_FAD_FLEX;
  snCurveId: number;
  anularCondition: ANNULUS_CONDITION;
  structures: FadFlexStructure[];

  constructor(
    props = {
      id: null,
      histogram: false,
      frictionCoefficient: 0,
      snCurveId: -1,
      detailedResults: DETAILED_RESULTS_FAD_FLEX.NONE,
      anularCondition: ANNULUS_CONDITION.DRY,
      structures: [],
    },
  ) {
    Object.assign(this, props);
  }
}
